import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastOptions: Partial<IndividualConfig> = {
    closeButton: true,
    progressBar: true,
    timeOut: 6000,
    positionClass: 'toast-bottom-right',
    enableHtml: false,
    tapToDismiss: true,
    newestOnTop: true,
    easeTime: 300,
    easing: 'ease-in',
    toastClass: 'ngx-toastr custom-toast',
    titleClass: 'toast-title',
    messageClass: 'toast-message',
  };

  constructor(private toastrService: ToastrService) {}

  showSuccess(title: string, message?: string) {
    this.toastrService.success(title, this.formatMessage(message), this.toastOptions);
  }

  showError(title: string, message?: string) {
    this.toastrService.error(title, this.formatMessage(message), this.toastOptions);
  }

  showInfo(title: string, message?: string) {
    this.toastrService.info(title, this.formatMessage(message), this.toastOptions);
  }

  showWarning(title: string, message?: string) {
    this.toastrService.warning(title, this.formatMessage(message), this.toastOptions);
  }

  private formatMessage(message?: string): string {
    return message || '';
  }
}
